module.exports = __webpack_public_path__ + "static/metal-builds-hero-69a7d14352e7fb6c3e1f3745fffe7924.png";